import {
  handleCatchErrors,
  responseDataFormat,
} from "../../../middlewares/resolveRequests";
import { getFiles, searchFiles } from "../../../services/files/files";

export const getAllAttachments = async (
  pageNumber = 1,
  pageSize = 20,
  token
) => {
  let response;
  try {
    response = await getFiles(pageNumber, pageSize, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const searchAllFiles = async (
  pageNumber = 1,
  pageSize = 10,
  communityId,
  data = {},
  token
) => {
  let response;
  try {
    response = await searchFiles(
      pageNumber,
      pageSize,
      communityId,
      data,
      token
    );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
